export default {
	debug: 'border: 1px solid red;',
	colors: {
		newBrand: {
			brandDark: '#CF4C29',
			coolGrey: '#A6AAB1',
			black: '#333333',
			lightGrey: '#606368',
			gray: '#DFDFDF',
			gray1: '#C0C2C8',
			navigationGray: '#F8F8F8',
			orange: '#FC5B30',
			turquoise: '#0FB8C6',
			darkTurquoise: '#0c919c',
			yellow: '#EFA20F',
			purple: '#789EE8',
			lightBackground: 'rgba(120, 158, 232, 0.07)',
			lightTurquoise: 'rgba(15,184,198, 0.07)',
			lightOrange: 'rgba(252,91,48, 0.07)',
		},
		gradients: {
			cta: 'linear-gradient(59deg, rgba(120,158,232,1) 5%, rgba(149,162,216,1) 19%, rgba(143,157,191,1) 42%, rgba(149,162,216,1) 65%, rgba(120,158,232,1) 95%)',
			screenshotBlockBlue:
				'linear-gradient(145deg, rgba(186,225,202,1) 14%, rgba(15,184,198,1) 51%, rgba(198,237,236,1) 91%)',
			screenshotBlockPurple:
				'linear-gradient(45deg, rgba(221,229,248,1) 11%, rgba(184,202,241,1) 37%, rgba(193,184,210,1) 69%, rgba(221,229,248,1) 95%)',
			screenshotBlockYellow:
				'linear-gradient(100deg, rgba(253,218,189,1) 9%, rgba(248,182,130,1) 37%, rgba(250,174,117,1) 71%)',
			accordionBackground:
				'linear-gradient(25deg, rgba(238,242,252,1) 6%, rgba(248,241,243,1) 21%, rgba(232,239,251,1) 37%, rgba(255,255,255,1) 60%)',
		},
		screenshotBg: [
			'linear-gradient(145deg, rgba(186,225,202,1) 14%, rgba(15,184,198,1) 51%, rgba(198,237,236,1) 91%)',
			'linear-gradient(45deg, rgba(221,229,248,1) 11%, rgba(184,202,241,1) 37%, rgba(193,184,210,1) 69%, rgba(221,229,248,1) 95%)',
			'linear-gradient(100deg, rgba(253,218,189,1) 9%, rgba(248,182,130,1) 37%, rgba(250,174,117,1) 71%)',
			'linear-gradient(145deg, rgba(186,225,202,1) 14%, rgba(15,184,198,1) 51%, rgba(198,237,236,1) 91%)',
			'linear-gradient(45deg, rgba(221,229,248,1) 11%, rgba(184,202,241,1) 37%, rgba(193,184,210,1) 69%, rgba(221,229,248,1) 95%)',
		],
		// primary is orange, secondary is blue, tertiary is yellow
		brand: {
			main: '#fc5b30', // Submittable orange
			contrastText: '#fff',
			rgb: '252, 91, 48',
		},
		brandMain: '#FC5B30',
		primary: {
			main: '#fd8464', // lighter orange
			dark: '#c93007',
			light: '#fdad97',
			lighter: '#feded6',
			lightest: '#feeeea',
			contrastText: '#fff',
		},
		secondary: {
			main: '#0fb8c6', // teal
			dark: '#007682',
			light: '#6fd4dd',
			lighter: '#b7e9ed',
			lightest: '#e7f7f9',
			contrastText: '#fff',
			rgb: '15, 184, 198',
		},
		tertiary: {
			main: '#ffc421', // yellow
			dark: '#e78f06',
			light: '#ffdc7a',
			lighter: '#ffedbc',
			lightest: '#fff9e8',
			contrastText: '#fff',
			alt: '#EFA20F',
			rgb: '255, 196, 33',
		},
		quaternary: {
			main: '#6C9EEE', // blue
			dark: '#789EE8',
			light: '#94B8F2',
			lighter: '#EBF1FC',
			lightest: '#CCDFFD',
			rgb: '108, 158, 238',
		},
		grayscale: {
			white: '#fff',
			black: '#000',
			gray1: '#B5B5B5',
			charcoal: '#333333',
			gray: '#9b9b9b',
			stone: '#f6f6f6',
			main: '#333',
			light: '#f6f6f6',
			lighter: '#dedede',
			dark: '#707070',
		},
		impactStudioBrand: {
			black: '#161616',
			grey: '#8B8B8B',
			blue: '#C9D8F6',
			purple: '#4E73CA',
		},
		impactStudio23Theme: {
			darkGreen: '#064A4F',
		},
		error: '#CF000F',
		blue: '#1E506A',
		white: '#ffffff',
		offWhite: '#f6f6f6',
		orange: '#FC5B30',
		lightGray: '#f6f6f6',
		darkGray: '#707070',
		gray: '#9b9b9b',
		black: '#333333',
		darkBlue: '#34344A',
		blueBlack: '#383C4B',
		salmon: '#FF9477',
		pink: '#F7A893',
		lightPink: '#FBE1DA',
	},

	accents: ['#3AB8C6', '#FFC421', '#FD8464', '#6C9EEE'], // blue, yellow, orange, blue
	lightAccents: [
		'#FFEDBC',
		'#FFDC7A',
		'#FFC421',
		'#FEDED6',
		'#FDAD97',
		'#FD8464',
		'#B7E9ED',
		'#6FD4DD',
		'#0FB8C6',
		'#9B9B9B',
	],
	productSubLevelColors: [
		// overview - orange
		{
			mainColor: '#FC5B30',
			gradients: {
				light: 'rgba(252,91,48,.10)',
				mid: 'rgba(252,91,48,.20)',
			},
		},
		// goverment - teal
		{
			mainColor: '#0FB8C6',
			gradients: {
				light: 'rgba(15,184,198,.10)',
				mid: 'rgba(15,184,198,.20)',
			},
		},
		// foundations - yellow
		{
			mainColor: '#EFA20F',
			gradients: {
				light: 'rgba(239,162,15,.10)',
				mid: 'rgba(239,162,15,.20)',
			},
		},
		// corporations - blue
		{
			mainColor: '#789EE8',
			gradients: {
				light: 'rgba(120,158,232,.10)',
				mid: 'rgba(120,158,232,.20)',
			},
		},
	],
	button: {
		text: '#fff',
		primary: '#FC5B30', // orange
		primaryShadow: '#fd8464', // light orange
		secondary: '#f6f6f6', // offwhite
		disabled: '#707070',
		disabledHover: 'transparent',
		borderRadius: '0px',
		pillRadius: '20px',
	},
	card: {
		cardPadding: 30,
	},
	link: {
		secondary: '#868686', // gray
		primary: '#3367D6', // blue
	},
	footer: {
		background: '#333', // black
		categoryTitle: '#fff',
	},
	section: {
		topBottomSpace: '100px',
		backgroundPrimary: '#fff',
		backgroundSecondary: '#f6f6f6',
	},
	navbarHeight: 84,
	intercomZIndex: 2147483000,
	navbarZIndex: 10,
	modalZIndex: 200,
	transitionDuration: '0.10s',
	boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2)',
	cardBoxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.10)',
	newCardBoxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.08)',
	hoverBoxShadow: '0 2px 29px 0px rgba(0, 0, 0, 0.3)',
	imageBoxShadow: '0 2px 14px 0 rgba(0,0,0,0.10)',
	focusBoxShadow: '0 0 3pt 2pt #FC5B30',
	borderRadius: '5px',
	spacingUnit: 8,
	image: {
		responsiveImage: `max-width: 100%; 
        display: block; 
        height: auto;`,
	},
	forms: {
		background: '#fff',
		textColor: '#333',
		borderRadius: '0px',
		inputs: {
			innerPadding: 10,
			labelHeight: 22.2,
			height: 44,
			boxShadow: 'inset -1px 1px 2px 1px rgba(31,28,78,0.2)',
			backgroundColor: '#F6F6F6',
		},
	},
	wistiaIds: {
		demoVideo: 'kectnmi4i6', // demo-video all
		general: 'kectnmi4i6', // demo-video all
		grant: '85b8sn6uj3', // demo-video grants
		grants: '85b8sn6uj3', // demo-video grants
		grantsDemo: '85b8sn6uj3', // demo-video grants
		grantDemo: '85b8sn6uj3', // added because someone sent out utm with grantDemo instead >:(
		Grantmaking: '85b8sn6uj3',
		publishingDemo: '8tzjnayhyj', // NOT USED
		contestsDemo: '9pfzazcsar', // NOT USED
		meetSubmittable: 'kahcffdfte', // on: submission-management-software
		meetSubmittableNoGate: 'g360czr25d', // on: CLPs
		submitterDemo: '8215u12shf', // NOT USED, REDIRECT TO DISCOVER.SUBMITTABLE.COM INSTEAD
		coldLandingPage: 'if77oirl9h', // OLD
	},
	breakPoints: {
		mobile: '425px',
		small: '576px',
		medium: '768px',
		large: '992px',
		extraLarge: '1200px',
		screenQuery: {
			extraMobile: '@media screen and (max-width: 366px)',
			mobile: '@media screen and (max-width: 424px)',
			small: '@media screen and (max-width: 575px)',
			medium: '@media screen and (max-width: 767px)',
			large: '@media screen and (max-width: 991px)',
			extraLarge: '@media screen and (max-width: 1199px)',
		},
		mobileFirstScreenQuery: {
			xsmall: '@media screen and (min-width: 424px)',
			small: '@media screen and (min-width: 575px)',
			medium: '@media screen and (min-width: 767px)',
			large: '@media screen and (min-width: 991px)',
			extraLarge: '@media screen and (min-width: 1199px)',
			doubleXLarge: '@media screen and (min-width: 1536px)',
			tripleXLarge: '@media screen and (min-width: 2000px)',
		},
	},
	font: {
		regular: 'ProximaNova-Regular',
		semiBold: 'ProximaNova-Semibold',
		bold: 'ProximaNova-Bold',
		recoleta: 'RecoletaAlt-Regular',
		recoletaMedium: 'Recoleta-Medium',
		recoletaBold: 'RecoletaAlt-Bold',
		recoletaSemiBold: 'RecoletaAlt-SemiBold',
		athletic: 'Athletics-Regular',
		athleticBold: 'Athletics-ExtraBold',
		athlieticItalic: 'Athletics-RegularItalic',
		avenir: 'nunitoregular',
		size: {
			small: '20px',
			medium: '28px',
			large: '34px',
		},
	},
	fontSize: {
		'1x': '.8rem', // 8px
		'2x': '1.6rem', // 16px
		'3x': '2.4rem', // 24px
		'4x': '3.2rem', // 32px
		'5x': '4rem', // 40px
		'6x': '4.8rem', // 48px
		'7x': '5.6rem', // 56 px
		'8x': '6.4rem', // 64rem
		'9x': '7.2rem', // 72rem
		'10x': '8.0rem', // 80rem
	},
	gridMarginBottom: `
        margin-bottom: 60px;
        @media screen and (max-width: 991px) {
            margin-bottom: 40px;
        }
        @media screen and (max-width: 575px) {
            margin-bottom: 30px;
        }
    `,
	gridMarginTop: `
        margin-top: 60px;
        @media screen and (max-width: 991px) {
            margin-top: 40px;
        }
        @media screen and (max-width: 575px) {
            margin-top: 30px;
        }
    `,
	impactReport2023Theme: {
		color: {
			primary_text: '#F8F4E9',
			secondary: '#EFA20F',
		},
		themeStyle: {
			themeA: {
				color_hex: '#064A4F',
				color_rgb: '6, 74, 79',
			},
			themeB: {
				color_hex: '#8E492E',
				color_rgb: '142, 73, 46',
			},
			themeC: {
				color_hex: '#485F8B',
				color_rgb: '72, 95, 139',
			},
			themeD: {
				color_hex: '#546242',
				color_rgb: '84, 98, 66',
			},
			themeE: {
				color_hex: '#985E0B',
				color_rgb: '152, 94, 11',
			},
		},
	},
	aiPageTheme: {
		color: {
			white: '#F2F0EE',
			black: '#0A1322',
		},
	},
	whySubmittableTheme: {
		color: {
			cream: '#F4F3EF',
			white: '#F8F4E9',
			white_rgb: '248, 244, 233',
			green: '#5E6C4B',
			darkGreen: '#495638',
			creamGreen: '#868D76',
			blue: '#E0E5E0',
			darkBlue: '#D5DDD8',
		},
	},
	comparisonTheme: {
		color: {
			lightPurple: '#DEE7F6',
		},
	},
	hubTheme: {
		color: {
			yellow: {
				hex: '#EFA30F',
				rgb: '239, 163, 15',
			},
			blue: {
				hex: '#789EE8',
				rgb: '120, 158, 232',
			},
			orange: {
				hex: '#FC5B30',
				rgb: '252, 91, 48',
			},
		},
	},
	resourceHubTheme: {
		color: {
			white: '#F3F1E6',
			black: '#131E33',
			grey: '#9A9BA0',
			tan: '#F3EEEE',
		},
	},
};
